import { render, staticRenderFns } from "./slider_nav.vue?vue&type=template&id=c238c690"
import script from "./slider_nav.vue?vue&type=script&lang=js"
export * from "./slider_nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports